module.exports = __webpack_public_path__ + "static/media/add_guest.eec3aafb.svg";